import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Helpers
import {checkValidity} from '../../helpers/helpers.js';

// Dependencies
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

// Components
import * as icons from '../Icons/Icons';
import Availability from './Availability';

const CalendarSettings = observer(class CalendarSettings extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.handleInput = this.handleInput.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.state = {
      enableArrivalManagement: false,
      maxStartingAppointments: null,
      useSeatManagement: false,
      enableLockoutPeriod: false,
      lockoutPeriod: null,
      lockoutPeriodUnits: null,

      title: '',
      numberOfSeats: '',
      interval: '',
      endBuffer: '',
      activeTab: 0,
      calendarRetrieved: false
    }
  }

  componentDidMount() {
    const { ScheduleStore } = this.props.store;


    if(this.props.calendarSid) {
      // If editing, get the calendar
      const callback = (data) => {
        this.setState({
          title: data.title,
          numberOfSeats: data.numberOfSeats,
          useSeatManagement: data.useSeatManagement,
          enableLockoutPeriod: data.schedule.enableLockoutPeriod,
          maxStartingAppointments: data.schedule.maxStartingAppointments,
          enableArrivalManagement: data.schedule.enableArrivalManagement,
          lockoutPeriod: data.schedule.lockoutPeriod,
          lockoutPeriodUnits: data.schedule.lockoutPeriodUnits,
          interval: data.schedule.interval,
          endBuffer: data.schedule.endBuffer,
          calendarRetrieved: true
        });
      }
      ScheduleStore.getCalendar(this.props.locationSid, this.props.calendarSid, callback);
    }
  }

  handleInput() {
    const title = this.title.value;
    const numberOfSeats = this.numberOfSeats.value;
    const interval = this.interval.value ? parseInt(this.interval.value, 10) : null;
    const endBuffer = this.endBuffer.value ? parseInt(this.endBuffer.value, 10) : null;

    this.setState({
      title,
      numberOfSeats,
      interval,
      endBuffer
    })
  }

  handleSubmit() {
    const { translation } = this.props;
    const { ScheduleStore, SessionStore } = this.props.store;
    let callback = null;

    const data = {
      title: this.state.title,
      numberOfSeats: this.state.numberOfSeats,
      interval: this.state.interval,
      endBuffer: this.state.endBuffer,
      enableArrivalManagement: this.state.enableArrivalManagement,
      maxStartingAppointments: (this.state.maxStartingAppointments && this.state.enableArrivalManagement) ? parseInt(this.state.maxStartingAppointments, 10) : null,
      useSeatManagement: this.state.useSeatManagement,
      enableLockoutPeriod: this.state.enableLockoutPeriod,
      lockoutPeriod: this.state.enableLockoutPeriod ? (this.state.lockoutPeriod) : null,
      lockoutPeriodUnits: this.state.enableLockoutPeriod ? this.state.lockoutPeriodUnits: null
    }

    if(this.props.calendarSid) {
      // Editing, so run update API call
      callback = () => {
        SessionStore.showToaster(translation.updated, 'success');
      }

      ScheduleStore.updateCalendar(this.props.locationSid, this.props.calendarSid, data, callback);

    } else {
      // Creating a new calendar
      callback = (data) => {
        let pathname = this.props.routing.location.pathname;

        pathname += `/calendar/${data.sid}`;

        this.props.routing.history.push(pathname);

        SessionStore.showToaster(translation.created, 'success');
      }

      ScheduleStore.createCalendar(this.props.locationSid, data, callback);
    }
    this.props.setStep(1);
    ScheduleStore.getLocationCalendars(this.props.locationSid);

  }

  render() {
    const { translation } = this.props;
    const { ScheduleStore } = this.props.store;
    const { locationCalendar } = ScheduleStore;

    // Don’t use the default tab styles
    Tabs.setUseDefaultStyles(false);

    if((this.props.calendarSid && this.state.calendarRetrieved) || !this.props.calendarSid) {
      return (
        <div className="panel--brief panel--brief-alt --xlarge">
          <button
            className="panel__close"
            onClick={() => this.props.setStep(1)}
          >
            <icons.iconTimes />
            <span className="meta">{translation.cancel}</span>
          </button>

          {this.props.calendarSid &&
            <h2 className="panel__title">{locationCalendar.title}</h2>
          }

          {!this.props.calendarSid &&
            <h2 className="panel__title">{translation.heading_new}</h2>
          }

          <Tabs
            onSelect={this.handleTabs}
            selectedIndex={this.state.activeTab}
          >
            <TabList className="tabs-sm">
            {/* <TabList className="tabs-disabled tabs-sm"> */}
              <Tab>{translation.tabs.settings}</Tab>
              <Tab>{translation.tabs.availability}</Tab>
            </TabList>

            <TabPanel>
              <form onSubmit={(e) => checkValidity(e, this.handleSubmit)}
              noValidate>
                <fieldset>
                  <ul className="fields">
                    <li>
                      <label htmlFor="calendar-name">{translation.name}</label>

                      <input
                        type="text"
                        defaultValue={this.state.title}
                        onChange={this.handleInput}
                        ref={(input) => this.title = input}
                        required
                        aria-required="true"
                      />
                    </li>
                    <li>
                      <label>{translation.seat_management}</label>
                      <input
                          checked={this.state.useSeatManagement}
                          id='seat-management'
                          type="checkbox"
                          className="switch-input"
                          onClick={() => this.setState((prevState) => ({ useSeatManagement: !prevState.useSeatManagement }))}
                      />
                      <label className="switch-label" htmlFor={`seat-management`} checked={true}></label>

                    </li>
                    <li>
                      <label htmlFor="calendar-seats">{translation.seats}</label>
                      <input
                          type="number"
                          defaultValue={this.state.numberOfSeats}
                          onChange={this.handleInput}
                          ref={(input) => this.numberOfSeats = input}
                          step="1"
                          min="1"
                          required
                          aria-required="true"
                      />
                    </li>
                    <li>
                      <label htmlFor="arrival-management">{translation.arrival_management}</label>
                      <input
                          type="checkbox"
                          className="switch-input"
                          id="arrival-management"
                          onChange={() => this.setState((prevState) => ({ enableArrivalManagement: !prevState.enableArrivalManagement}))}
                          checked={this.state.enableArrivalManagement}
                          defaultChecked={this.state.enableArrivalManagement}
                      />
                      <label className="switch-label" htmlFor='arrival-management'></label>
                    </li>
                    {this.state.enableArrivalManagement &&
                      <li>
                        <label htmlFor="max-appointments">{translation.max_appointments_label}</label>
                        <input
                            type="number"
                            id="max-appointments"
                            defaultValue={this.state.maxStartingAppointments}
                            onChange={e => this.setState({maxStartingAppointments: e.target.value})}
                            required
                            aria-required="true"
                        />
                      </li>
                    }

                    <li>
                      <label htmlFor="lockout-period">{translation.enable_lockout_period}</label>
                      <input
                          type="checkbox"
                          className="switch-input"
                          onChange={() => this.setState((prevState) => ({ enableLockoutPeriod: !prevState.enableLockoutPeriod}))}
                          checked={this.state.enableLockoutPeriod}
                          id="lockout-period"
                      />
                      <label className="switch-label" htmlFor={`lockout-period`}><span className="meta"></span></label>

                    </li>

                    {this.state.enableLockoutPeriod &&
                      <li>
                        <label htmlFor="enable-lockout">{translation.lockout_period}</label>
                        <input
                            type="number"
                            id="enable-lockout"
                            defaultValue={this.state.lockoutPeriod}
                            onChange={e => this.setState({lockoutPeriod: e.target.value})}
                            required
                            aria-required="true"
                        />
                      </li>
                    }
                    {this.state.enableLockoutPeriod &&
                      <li>
                        <label htmlFor="lockout-unit-select">{translation.lockout_period_units}</label>
                        <label className="select">
                          <select
                              id="lockout-unit-select"
                              onChange={e => this.setState({lockoutPeriodUnits: e.target.value})}
                              defaultValue={this.state.lockoutPeriodUnits}
                              required
                          >
                            <option value="">{translation.select_placeholder}</option>
                            <option value="business">{translation.business}</option>
                            <option value="actual">{translation.actual}</option>
                          </select>
                        </label>
                      </li>

                    }
                    <li>
                      <label htmlFor="calendar-interval">{translation.start_times}</label>

                      <input
                        type="number"
                        id="calendar-interval"
                        defaultValue={this.state.interval}
                        onChange={this.handleInput}
                        ref={(input) => this.interval = input}
                        step="1"
                        min="0"
                        required
                        aria-required="true"
                      />

                      <span className="preposition form-note">
                        {
                          this.state.interval !== 1 &&
                          this.state.interval !== 0 &&
                          this.state.interval !== null &&
                          translation.start_times_helper.replace('%time%', this.state.interval)
                        }

                        {this.state.interval === 1 &&
                          translation.start_times_helper_single.replace('%time%', this.state.interval)
                        }

                        {!this.state.interval &&
                          translation.start_times_helper.replace('%time%', 'X')
                        }
                      </span>
                    </li>
                    <li>
                      <label htmlFor="calendar-buffer">{translation.buffer}</label>

                      <input
                        type="number"
                        id="calendar-buffer"
                        defaultValue={this.state.endBuffer}
                        onChange={this.handleInput}
                        ref={(input) => this.endBuffer = input}
                        step="1"
                        min="0"
                        required
                        aria-required="true"
                      />

                      <span className="preposition form-note">
                        {
                          this.state.endBuffer !== 1 &&
                          this.state.endBuffer !== 0 &&
                          this.state.endBuffer !== null &&
                          translation.buffer_helper.replace('%time%', this.state.endBuffer)
                        }

                        {this.state.endBuffer === 1 &&
                          translation.buffer_helper_single.replace('%time%', this.state.endBuffer)
                        }

                        {!this.state.endBuffer &&
                          translation.buffer_helper.replace('%time%', 'X')
                        }
                      </span>
                    </li>
                  </ul>
                </fieldset>

                <div className="panel__btns">
                  <button className="btn btn--inline" type="submit">
                    {translation.button}
                  </button>

                  <button
                    className="btn--link"
                    onClick={() => this.props.setStep(1)}
                  >
                    {translation.cancel}
                  </button>
                </div>
              </form>
            </TabPanel>

            <TabPanel>
              <Availability
                {...this.props}
                defaultNumberOfSeats={this.state.numberOfSeats}
                dayOfWeek={[0, 1, 2, 3, 4, 5, 6]}
                callback={() => {
                  this.setState({
                    editAvailability: false,
                    editAvailabilityDate: null,
                    editAvailabilityDayOfWeek: null,
                    editAvailabilitiesDefault: []
                  })
                }}
              />
            </TabPanel>
          </Tabs>
        </div>
      )
    }

    return null;
  }
})

export default translate('CalendarSettings')(CalendarSettings);



// WEBPACK FOOTER //
// ./src/app/components/Schedule/CalendarSettings.js